import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import classNames from 'classnames';
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'src/i18n';
import CardMembershipIcon from '@mui/icons-material/CardMembershipSharp';
import HelpIcon from '@mui/icons-material/HelpOutlineSharp';
import ContactIcon from '@mui/icons-material/PhoneSharp';
import LogOutIcon from '@mui/icons-material/ExitToAppSharp';
import InfoIcon from '@mui/icons-material/InfoSharp';
import CircuitIcon from '@mui/icons-material/AccountTreeSharp';
import MaintenanceIcon from '@mui/icons-material/SecuritySharp';
import ReportIcon from '@mui/icons-material/MailSharp';
import DashboardIcon from '@mui/icons-material/PollSharp';
import SwitchClientIcon from '@mui/icons-material/ShuffleSharp';
import FacilityIcon from '@mui/icons-material/BusinessSharp';
import AlarmsIcon from '@mui/icons-material/NotificationsActiveSharp';
import HistoryIcon from '@mui/icons-material/HistorySharp';
import IntegrationsIcon from '@mui/icons-material/ExtensionSharp';
import AccountCircleIcon from '@mui/icons-material/AccountCircleSharp';
import NotesIcon from '@mui/icons-material/BorderColorSharp';
import PestControlRodentIcon from '@mui/icons-material/PestControlRodentSharp';
import PhonelinkLockIcon from '@mui/icons-material/PhonelinkLockSharp';
import ForcedOnIcon from '@mui/icons-material/OfflineBoltSharp';
import FreezeLogsIcon from '@mui/icons-material/AcUnitSharp';
import ReplaceDeviceIcon from '@mui/icons-material/AutoFixHighSharp';
import NotificationIcon from '@mui/icons-material/AssignmentSharp';
import UpgradePathIcon from '@mui/icons-material/ForkRightSharp';
import CategoryIcon from '@mui/icons-material/CategorySharp';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettingsSharp';

import RulesIcon from '@mui/icons-material/TuneSharp';
import ScheduleIcon from '@mui/icons-material/ScheduleSharp';
import SupportIcon from '@mui/icons-material/SupportSharp';
import EhtGroupLogo from '@mui/icons-material/FilterHdrSharp';
import PortableWifiOffIcon from '@mui/icons-material/PortableWifiOffSharp';
import ConfigureSearchIcon from '@mui/icons-material/ManageSearchSharp';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggestSharp';
import KeyIcon from '@mui/icons-material/KeySharp';
import Divider from "@mui/material/Divider";
import { Map } from 'immutable';
import { useLocation } from 'react-router-dom';
import NavBarItem from 'src/component/UI/NavBar/NavBarItem';
import SubNavBarItem from 'src/component/UI/NavBar/SubNavBarItem';
import PermissionFence from 'src/component/PermissionFence';
import ChangeClientModal from 'src/component/UI/ChangeClientModal';
import { getClientsForUser, getClientId, getAuthenticatedUser, getClient, getPluralWorkTicketLabel, getTrainingURL, getTrainingPassword } from 'src/module/authentication/selector';
import { changeClient } from 'src/module/authentication/action';
import { updateUser } from 'src/module/user/action';
import LightbulbIcon from '@mui/icons-material/LightbulbSharp';
import MenuIcon from '@mui/icons-material/MenuSharp';
import PublishIcon from '@mui/icons-material/PublishSharp';
import { Popover } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import NavBarCategoryItem from 'src/component/UI/NavBar/NavBarCategoryItem';
import { CompareArrowsSharp as CompareArrows, MoreVertSharp as MoreVert } from '@mui/icons-material';
import variables from 'src/style/variable/variables.module.scss';
import DifferenceIcon from '@mui/icons-material/DifferenceSharp';
import FeatureFence from 'src/component/FeatureFence';
import AtcomLogo from 'src/component/UI/AtcomLogo';
import { useEmail, isWhitelabel, useAlarmReports, useAdvancedSearch } from 'src/utils/utils';
import SummarizeIcon from '@mui/icons-material/SummarizeSharp';
import smarttrace from 'src/assets/raychem-smarttrace-white.svg';

export default function SideNavBar (props) {
  const dispatch: any = useDispatch();
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
  const [openAlarmsCategory, setOpenAlarmsCategory] = useState(false);
  const [openDevicesCategory, setOpenDevicesCategory] = useState(false);
  const [openSettingsPopOver, setOpenSettingsPopOver] = useState(false);
  const [changeFacilityPopOver, setChangeFacilityPopOver] = useState(false);
  const [anchorElForFacility, setAnchorElForFacility] = useState<HTMLDivElement | null>(null);

  const clients: any = useSelector(getClientsForUser);
  const user = useSelector(getAuthenticatedUser);
  const pluralWorkTicketLabel = useSelector(getPluralWorkTicketLabel);
  const currentClientId: any = useSelector(getClientId);
  const client = useSelector(getClient);

  const clientName = client?.get('name');
  const whitelabel = isWhitelabel();

  const [open, setOpen] = useState(user.getIn(['preferences', 'navbarOpen'], true));
  const isMobile = useMediaQuery(`(max-width: ${variables.mobileWidth})`);

  const trainingURL = useSelector(getTrainingURL);
  const trainingPassword = useSelector(getTrainingPassword);

  const [useEmailValue, setUseEmailValue] = useState<boolean | null>(null);
  const [useEmailLoading, setUseEmailLoading] = useState(true);
  const [useAlarmReportsValue, setUseAlarmReportsValue] = useState<boolean | null>(null);
  const [useAlarmReportsLoading, setUseAlarmReportsLoading] = useState(true);
  const [useAdvancedSearchValue, setUseAdvancedSearchValue] = useState<boolean | null>(null);

  useEffect(() => {
    async function loadData () {
      const emailResult = await useEmail();
      setUseEmailValue(emailResult);
      setUseEmailLoading(false);
      const alarmReportsResult = await useAlarmReports();
      setUseAlarmReportsValue(alarmReportsResult);
      setUseAlarmReportsLoading(false);
      const advancedSearchResult = await useAdvancedSearch();
      setUseAdvancedSearchValue(advancedSearchResult);
    }
    loadData();
  }, []);

  const className = open ? "bigNav" : "smallNav";

  const closeAllCategories = () => {
    setOpenAlarmsCategory(false);
    setOpenDevicesCategory(false);
  };
  const handleClickOnAlarmsCategory = () => {
    closeAllCategories();
    setOpenAlarmsCategory(!openAlarmsCategory);
  };
  const handleClickOnDevicesCategory = () => {
    closeAllCategories();
    setOpenDevicesCategory(!openDevicesCategory);
  };
  const handleClickOnHeader = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
    setOpenSettingsPopOver(!openSettingsPopOver);
  };

  //  purpose: returns true if any of the sub categories links are open
  //  how: checks if the path exists in the array of string (routes)
  const isCategoryActive = (routes: Array<string>) => {
    const location = useLocation();
    return routes.includes(location.pathname.replace("/", "")) || routes.includes(location.pathname.split('/')[1]);
  };

  const toggleDrawer = () => {
    dispatch(updateUser(null, Map({ navbarOpen: !open })));

    setOpen(!open);
    if (open) {
      closeAllCategories();
    }
    props.onToggleDrawer(!open);
  };

  const handleChangeClient = (clientId) => {
    handleCloseSettingsPopOver();
    dispatch(updateUser(null, Map({ defaultFacility: clientId })));
    dispatch(changeClient(clientId));
    if (isMobile) {
      toggleDrawer();
    }
  };


  const handleCloseSettingsPopOver = () => {
    setAnchorEl(null);
    setOpenSettingsPopOver(!openSettingsPopOver);
  };
  const handleClickOnChangeFacility = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorElForFacility(changeFacilityPopOver ? null : event.currentTarget);
    setChangeFacilityPopOver(!changeFacilityPopOver);
  };
  const handleCloseChangeFacility = () => {
    setAnchorElForFacility(null);
    setChangeFacilityPopOver(!changeFacilityPopOver);
  };
  const handleMobileDrawerItemClick = () => {
    if (!isMobile) {
      return;
    }

    toggleDrawer();
  };

  function menuHeader () {

    const whiteListLogo = <AtcomLogo size={24} color='#fff' square />;
    const whiteListLabelHTML = <AtcomLogo size={90} color='#fff' textOnly />;

    const effectiveOpen = isMobile || open;
    const regLogo = (
      <div style={{ opacity: effectiveOpen ? 0 : 1, transition: 'opacity 250ms', transitionDelay: effectiveOpen ? '0ms' : '200ms', display: 'flex', alignItems: 'center' }}>
        <EhtGroupLogo style={{ fontSize: 32 }} />
      </div>
    );
    const regName = (
      <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
        <img src={smarttrace} style={{ width: '211px', flexShrink: 0, zIndex: 500, marginLeft: '-61px', padding: '6px', paddingTop: '10px', opacity: effectiveOpen ? 1 : 0, transition: 'opacity 250ms', transitionDelay: effectiveOpen ? '200ms' : '0ms' }} />
        <MoreVert style={{ marginLeft: 'auto', color: 'white', flexShrink: 0 }} />
      </div>
    );

    if (whitelabel) {
      return <NavBarItem onClick={handleClickOnHeader} className={classNames('main', 'whitelabel')} icon={whiteListLogo} label={whiteListLabelHTML} />;
    } else {
      return <NavBarItem onClick={handleClickOnHeader} className='main' icon={regLogo} label={regName} />;
    }
  }


  return (
    <>
      <div id='navbar-header' data-testid='navbar-header'>
        {menuHeader()}
      </div>
      <div id='navbar-upper' data-testid='navbar-upper'>
        <div onClick={handleMobileDrawerItemClick}>
          <NavBarItem to='/' className={className} icon={<DashboardIcon style={{ fontSize: 24 }} />} label={t('nav.dashboard')} />
        </div>
        <NavBarCategoryItem
          isCategoryOpen={openAlarmsCategory}
          isNavBarOpen={isMobile ? true : open}
          triggerCategory={handleClickOnAlarmsCategory}
          label={t('nav.alarms')}
          options={<div onClick={handleMobileDrawerItemClick}>
            <PermissionFence can='read-eht-alarm'>
              <NavBarItem to='/alarms/active' label={t('nav.activeAlarms')} icon={<AlarmsIcon style={{ fontSize: 24 }} />} />
            </PermissionFence>
            <PermissionFence can='read-eht-alarm'>
              <FeatureFence can={['alarm-historian']}
                noPermissionComponent={<NavBarItem to='/alarms/history' locked label={t('nav.alarmHistorian')} icon={<HistoryIcon style={{ fontSize: 24 }} />} />}
              >
                <NavBarItem to='/alarms/history' label={t('nav.alarmHistorian')} icon={<HistoryIcon style={{ fontSize: 24 }} />} />
              </FeatureFence>
            </PermissionFence>
            <FeatureFence can={['alarm-validation']}
              noPermissionComponent={<NavBarItem to='/maintenance' locked label={t('nav.validate')} icon={<MaintenanceIcon style={{ fontSize: 24 }} />} />}
            >
              <NavBarItem to='/maintenance' label={t('nav.validate')} icon={<MaintenanceIcon style={{ fontSize: 24 }} />} />
            </FeatureFence>
          </div>}
          header={<PermissionFence can='read-eht-alarm'>
            <NavBarItem to='/alarms/active' disabled className={className} isActive={isCategoryActive(["alarms", "historian", "maintenance"])} isCategoryOpen={openAlarmsCategory} isCategory icon={<AlarmsIcon style={{ fontSize: 24 }} />} label={t('nav.alarms')} />
          </PermissionFence>}
        />

        <NavBarCategoryItem
          isCategoryOpen={openDevicesCategory}
          isNavBarOpen={isMobile ? true : open}
          triggerCategory={handleClickOnDevicesCategory}
          label={t('nav.devices')}
          options={<div onClick={handleMobileDrawerItemClick}>
            <PermissionFence can='read-device'>
              <NavBarItem to='/devices/list' label={t('nav.deviceList')} icon={<CircuitIcon style={{ fontSize: 24 }} />} />
            </PermissionFence>

            <PermissionFence can='read-device'>
              <NavBarItem to='/devices/comm-loops' label={t('nav.commLoops')} icon={<PortableWifiOffIcon style={{ fontSize: 24 }} />} />
            </PermissionFence>

            <PermissionFence can='read-device'>
              <FeatureFence can={['circuit-management']} noPermissionComponent={<NavBarItem to='/devices/groups' locked label={t('nav.groups')} icon={<CategoryIcon style={{ fontSize: 25 }} />} />}>
                <NavBarItem to='/devices/groups' label={t('nav.groups')} icon={<CategoryIcon style={{ fontSize: 25 }} />} />
              </FeatureFence>
            </PermissionFence>

            <PermissionFence can='edit-device'>
              <FeatureFence can={['circuit-management']} noPermissionComponent={<NavBarItem to='/devices/send-modbus-request' locked label={t('nav.modbusTool')} icon={<CompareArrows style={{ fontSize: 24 }} />} />}>
                <NavBarItem to='/devices/send-modbus-request' label={t('nav.modbusTool')} icon={<CompareArrows style={{ fontSize: 24 }} />} />
              </FeatureFence>
            </PermissionFence>

            <PermissionFence can='read-batch-schedule'>
              <FeatureFence can={['batches-and-recipes', 'program-device']}
                noPermissionComponent={<NavBarItem to='/program/list' locked label={t('nav.massProgram')} icon={<SettingsSuggestIcon style={{ fontSize: 24 }} />} />}
              >
                <NavBarItem to='/program/list/wizard' label={t('nav.massProgram')} icon={<SettingsSuggestIcon style={{ fontSize: 24 }} />} />
              </FeatureFence>
            </PermissionFence>

            <PermissionFence can='edit-device'>
              <FeatureFence can={['replace-device', 'program-device']}
                noPermissionComponent={<NavBarItem to='/devices/upgrade' label={t('nav.replaceDevice')} locked icon={<ReplaceDeviceIcon style={{ fontSize: 24 }} />} />}
              >
                <NavBarItem to='/devices/upgrade' label={t('nav.replaceDevice')} icon={<ReplaceDeviceIcon style={{ fontSize: 24 }} />} />
              </FeatureFence>
            </PermissionFence>

            <PermissionFence can='read-device'>
              <FeatureFence can={['programming-audit']}
                noPermissionComponent={<NavBarItem to='/devices/programming-audit' label={t('nav.programAudit')} locked icon={<DifferenceIcon style={{ fontSize: 24 }} />} />}
              >
                <NavBarItem to='/devices/programming-audit' label={t('nav.programAudit')} icon={<DifferenceIcon style={{ fontSize: 24 }} />} />
              </FeatureFence>
            </PermissionFence>

            <PermissionFence can='edit-device'>
              <FeatureFence can={['circuit-management']} noPermissionComponent={<NavBarItem to='/import/devices' locked label={t('nav.importDevices')} icon={<PublishIcon style={{ fontSize: 24 }} />} />}>
                <NavBarItem to='/import/devices' label={t('nav.importDevices')} icon={<PublishIcon style={{ fontSize: 24 }} />} />
              </FeatureFence>
            </PermissionFence>

            <PermissionFence can='read-eht-note'>
              <FeatureFence can={['eht-notes']}
                noPermissionComponent={<NavBarItem to='/notes/note' label={t('nav.notes')} locked icon={<NotesIcon style={{ fontSize: 24 }} />} />}
              >
                <NavBarItem to='/notes/note' label={t('nav.notes')} icon={<NotesIcon style={{ fontSize: 24 }} />} />
              </FeatureFence>
            </PermissionFence>

            <PermissionFence can='read-eht-note'>
              <FeatureFence can={['regulatory-reports']}
                noPermissionComponent={<NavBarItem to='/devices/reports' label={t('nav.reports')} locked icon={<SummarizeIcon style={{ fontSize: 25 }} />} />}
              >
                <NavBarItem to='/devices/reports' label={t('nav.reports')} icon={<SummarizeIcon style={{ fontSize: 25 }} />} />
              </FeatureFence>
            </PermissionFence>

          </div>}
          header={
            <PermissionFence can='read-device'>
              <NavBarItem to='/devices/list' disabled className={className} isActive={isCategoryActive(["devices", "notes/note", "program/list/wizard", "program/list/scheduled", "program/list/pending", "program/list/completed", "program/list/templates"])} isCategoryOpen={openDevicesCategory} isCategory icon={<CircuitIcon style={{ fontSize: 24 }} />} label={t('nav.devices')} />
            </PermissionFence>
          }
        />
        <div onClick={handleMobileDrawerItemClick}>
          <PermissionFence can='read-eht-note'>
            <FeatureFence can={['eht-notes']}
              noPermissionComponent={<NavBarItem to='/notes/loto' locked label={t('nav.loto')} icon={<PhonelinkLockIcon style={{ fontSize: 20 }} />} />}
            >
              <NavBarItem to='/notes/loto' className={className} icon={<PhonelinkLockIcon style={{ fontSize: 20 }} />} label={t('nav.loto')} />
            </FeatureFence>
          </PermissionFence>

          <PermissionFence can='read-eht-note'>
            <FeatureFence can={['eht-notes']}
              noPermissionComponent={<NavBarItem to='/notes/nuisance' locked label={t('nav.nuisance')} icon={<PestControlRodentIcon style={{ fontSize: 24 }} />} />}
            >
              <NavBarItem to='/notes/nuisance' className={className} icon={<PestControlRodentIcon style={{ fontSize: 24 }} />} label={t('nav.nuisance')} />
            </FeatureFence>
          </PermissionFence>

          <PermissionFence can='read-forced-on-circuit'>
            <FeatureFence can={['forced-on-logs']}
              noPermissionComponent={<NavBarItem to='/forced-on' locked label={t('nav.forcedOnCircuits')} icon={<ForcedOnIcon style={{ fontSize: 24 }} />} />}
            >
              <NavBarItem to='/forced-on' className={className} icon={<ForcedOnIcon style={{ fontSize: 24 }} />} label={t('nav.forcedOnCircuits')} />
            </FeatureFence>
          </PermissionFence>

          <PermissionFence can='read-freeze-log'>
            <FeatureFence can={['freeze-logs']}
              noPermissionComponent={<NavBarItem to='/freeze-logs' locked label={t('nav.freezeLogs')} icon={<FreezeLogsIcon style={{ fontSize: 24 }} />} />}
            >
              <NavBarItem to='/freeze-logs' className={className} icon={<FreezeLogsIcon style={{ fontSize: 24 }} />} label={t('nav.freezeLogs')} />
            </FeatureFence>
          </PermissionFence>

          <PermissionFence can='read-sap-notification'>
            <FeatureFence can={['work-tickets']}
              noPermissionComponent={<NavBarItem to='/notifications' locked label={pluralWorkTicketLabel ?? t('nav.workTickets')} icon={<NotificationIcon style={{ fontSize: 24 }} />} />}
            >
              <NavBarItem to='/notifications' className={className} icon={<NotificationIcon style={{ fontSize: 24 }} />} label={pluralWorkTicketLabel ?? t('nav.workTickets')} />
            </FeatureFence>
          </PermissionFence>

          {!useAlarmReportsLoading && (
            <PermissionFence can='send-report'>
              <FeatureFence can={['reporting']}
                noPermissionComponent={<NavBarItem to='/report' locked label={useAlarmReportsValue ? t('nav.buildAlarmReport') : t('nav.alarmReport')} icon={<ReportIcon style={{ fontSize: 24 }} />} />}
              >
                <NavBarItem to='/report' className={className} icon={<ReportIcon style={{ fontSize: 24 }} />} label={useAlarmReportsValue ? t('nav.buildAlarmReport') : t('nav.alarmReport')} />
              </FeatureFence>
            </PermissionFence>
          )}
        </div>

      </div>
      <div id='navbar-lower' data-testid='navbar-lower' >
        <NavBarItem subnavbar icon={<HelpIcon style={{ fontSize: 24 }} />} label={t('nav.help')} menuLabel={t('nav.helpMessage')}>
          <SubNavBarItem label={t('nav.contactUs')} to='https://ehtgroup.com/schedule-a-call/' icon={<ContactIcon style={{ fontSize: 20 }} />} />
          {
            !whitelabel ? <SubNavBarItem label={t('nav.knowledgeBase')} to='https://app.smarttrace.ai/knowledge/' icon={<SupportIcon style={{ fontSize: 20 }} />} /> : null
          }
          {trainingURL && trainingPassword ? <SubNavBarItem label={t('nav.training')} to='/training' icon={<LightbulbIcon style={{ fontSize: 20 }} />} /> : null}
          <div onClick={handleMobileDrawerItemClick}>
            <SubNavBarItem label={t('nav.about')} to='/about' icon={<InfoIcon style={{ fontSize: 20 }} />} />
          </div>
        </NavBarItem>

        {isMobile ? null : <NavBarItem className='collapse' onClick={toggleDrawer} icon={<MenuIcon style={{ fontSize: 24 }} />} label={t('nav.collapse')} />}
      </div>
      <Popover
        open={openSettingsPopOver}
        anchorEl={anchorEl}
        onClose={handleCloseSettingsPopOver}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        className="nav-popover-settings"
      >
        <div className='setting-popover-header'>
          <span>{clientName}</span>
        </div>
        <div onClick={handleMobileDrawerItemClick}>
          <PermissionFence can='edit-client'>
            <NavBarItem label={t('nav.facility')} to='/settings/facility' onClose={handleCloseSettingsPopOver} icon={<FacilityIcon style={{ fontSize: 20 }} />} />
          </PermissionFence>

          <PermissionFence can='edit-client'>
            <NavBarItem label={t('nav.manageLicense')} to='/settings/license-management' onClose={handleCloseSettingsPopOver} icon={<CardMembershipIcon style={{ fontSize: 20 }} />} />
          </PermissionFence>

          <PermissionFence can='edit-integration'>
            <NavBarItem label={t('nav.integrations')} to='/settings/integrations' onClose={handleCloseSettingsPopOver} icon={<IntegrationsIcon style={{ fontSize: 20 }} />} />
          </PermissionFence>

          {
            !useEmailLoading && useEmailValue && (
              <PermissionFence can='read-report-schedule'>
                <FeatureFence can={['reporting']}
                  noPermissionComponent={<NavBarItem to='/settings/schedule' locked label={t('nav.reportingSchedule')} icon={<ScheduleIcon style={{ fontSize: 20 }} />} />}
                >
                  <NavBarItem label={t('nav.reportingSchedule')} to='/settings/schedule' onClose={handleCloseSettingsPopOver} icon={<ScheduleIcon style={{ fontSize: 20 }} />} />
                </FeatureFence>
              </PermissionFence>
            )
          }


          <PermissionFence can='read-eht-alarm-rule'>
            <FeatureFence can={['criticality-ruleset']}
              noPermissionComponent={<NavBarItem to='/settings/rules' locked label={t('nav.criticalityRules')} icon={<RulesIcon style={{ fontSize: 20 }} />} />}
            >
              <NavBarItem label={t('nav.criticalityRules')} to='/settings/rules' onClose={handleCloseSettingsPopOver} icon={<RulesIcon style={{ fontSize: 20 }} />} />
            </FeatureFence>
          </PermissionFence>

          {useAdvancedSearchValue && <PermissionFence can='edit-client'>
            <FeatureFence can={['configure-search']}
              noPermissionComponent={<NavBarItem to='/settings/configure-search' locked label={t('nav.configureSearch')} icon={<ConfigureSearchIcon style={{ fontSize: 20 }} />} />}
            >
              <NavBarItem label={t('nav.configureSearch')} to='/settings/configure-search' onClose={handleCloseSettingsPopOver} icon={<ConfigureSearchIcon style={{ fontSize: 20 }} />} />
            </FeatureFence>
          </PermissionFence>}

          <PermissionFence can='read-api-key'>
            <NavBarItem label={t('nav.manageApiKeys')} to='/settings/api-keys' onClose={handleCloseSettingsPopOver} icon={<KeyIcon style={{ fontSize: 20 }} />} />
          </PermissionFence>

          <Divider variant="middle" />

          <PermissionFence can='super-admin'>
            <div className='setting-popover-header'>
              <span>{t('nav.superAdminMenu')}</span>
            </div>

            <NavBarItem label={t('nav.alarmGroupings')} to='/settings/alarm-simplification' onClose={handleCloseSettingsPopOver} icon={<AlarmsIcon style={{ fontSize: 20 }} />} />
            <NavBarItem label={t('nav.defineUpgradePath')} to='/settings/upgrade-path' onClose={handleCloseSettingsPopOver} icon={<UpgradePathIcon style={{ fontSize: 20 }} />} />
            <Divider variant="middle" />
          </PermissionFence>

          <div className={classNames('setting-popover-header', 'user-settings')}>
            <div className='user-initals'>{user.get('first_name')?.toUpperCase()[0]}{user.get('last_name')?.toUpperCase()[0]}</div>
            <div className='user-details'>
              <div>{user.get('first_name')} {user.get('last_name')}</div>
              <div className="user-email">{user.get('email')}</div>
            </div>
          </div>
          <NavBarItem label={t('nav.profile')} to='/profile' onClose={handleCloseSettingsPopOver} icon={<AccountCircleIcon style={{ fontSize: 20 }} />} />
        </div>
        {clients.size > 1 && (<NavBarItem label={t('nav.changeFacility')} to='#' isFlyOut onClick={handleClickOnChangeFacility} icon={<SwitchClientIcon style={{ fontSize: 20 }} />} />)}
        <PermissionFence can='smarttrace-admin'>
          <NavBarItem label={t('nav.administrator')} to='/admin' onClose={handleCloseSettingsPopOver} icon={<AdminPanelSettingsIcon style={{ fontSize: 20 }} />} />
        </PermissionFence>
        <NavBarItem label={t('nav.signOut')} to='/logout' icon={<LogOutIcon style={{ fontSize: 20 }} />} />
      </Popover>
      {/* popover / flyout for change facility, triggeted by click on change facility */}
      <Popover
        disableRestoreFocus
        open={changeFacilityPopOver}
        anchorEl={anchorElForFacility}
        onClose={handleCloseChangeFacility}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        className="nav-popover-settings"
      >
        <ChangeClientModal clients={clients} currentClientId={currentClientId} handleClose={handleCloseChangeFacility} handleSubmit={handleChangeClient} />
      </Popover>
    </>
  );
}
SideNavBar.propTypes = {
  onToggleDrawer: PropTypes.func
};

SideNavBar.defaultProps = null;
